import { myCarsInitialState } from '../ducks/initialState';

export default {
  myCars: myCarsInitialState,
};
